import * as React from "react";
const SvgPrimaryShare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#082B60"
      strokeWidth={1.25}
      d="m9.835 2.308 5.282 5.612a.39.39 0 0 1-.008.54l-5.282 5.282a.388.388 0 0 1-.663-.275v-3.192a.17.17 0 0 0-.133-.174c-.632-.135-3.464-.458-7.426 3.31-.285.27-.754.012-.645-.365 2.01-6.988 6.908-7.23 7.99-7.194a.207.207 0 0 0 .214-.205V2.574c0-.352.43-.522.671-.266Z"
    />
  </svg>
);
export default SvgPrimaryShare;
